export const FETCH_LEARNERS_ENGAGEMENT_SCORE = 'FETCH_LEARNERS_ENGAGEMENT_SCORE'
export const FETCH_LEARNERS_ENGAGEMENT_SCORE_SUCCESS =
  'FETCH_LEARNERS_ENGAGEMENT_SCORE_SUCCESS'
export const FETCH_LEARNERS_ENGAGEMENT_SCORE_FAILURE =
  'FETCH_LEARNERS_ENGAGEMENT_SCORE_FAILURE'

export const FETCH_LEARNERS_ENGAGEMENT_SCORE_CANCEL =
  'FETCH_LEARNERS_ENGAGEMENT_SCORE_CANCEL'
